var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowScrolldown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 3L4 37.935h19.543V64h32.914V37.935H76zM23.562 65.967h32.892v3H23.562zm0 5h32.892v2H23.562zm0 5h32.892v1H23.562z",
    fill: "#28dcaa",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowScrolldown);
export default __webpack_public_path__ + "static/media/arrow-scrolldown.ca819be6b37119e8f2d1472efc904bc9.svg";
export { ForwardRef as ReactComponent };